import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute, NavigationEnd, PRIMARY_OUTLET, Router, RouterModule } from '@angular/router';
import { filter, map } from 'rxjs';
import { FeatherIconsComponent } from '../feather-icons/feather-icons.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-breadcrumb',
  standalone:true,
  imports:[CommonModule,RouterModule,FeatherIconsComponent,TranslateModule],
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})

export class BreadcrumbComponent {

  public breadcrumbs: { parentBreadcrumb?: string; parentBreadcrumb2?: string; parentBreadcrumbId?: number; breadcrumbParentId2?: string; childBreadcrumb?: string; enable?: boolean };
  public title: string = '';
  public link: string = '';
  public linkId: string = '';
  public linkParent2: string = '';

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private translateService: TranslateService
  ) {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd)) // Filtra solo eventi NavigationEnd
      .pipe(map(() => this.activatedRoute))  // Ottiene la route attiva
      .pipe(map((route) => {
        while (route.firstChild) { // Trova la route più interna
          route = route.firstChild;
        }
        return route;
      }))
      .pipe(filter(route => route.outlet === PRIMARY_OUTLET))
      .subscribe(route => {
        let title = route.snapshot.data['title'] ? this.translateService.instant(route.snapshot.data['title']) : ''; // Ottiene il titolo dalla route
        let parent = route.parent?.snapshot.data['breadcrumb'] ? this.translateService.instant(route.parent.snapshot.data['breadcrumb']) : ''; // Ottiene il breadcrumb genitore
        let isEnable = route.parent?.snapshot.data['isEnable'] // Controlla se il breadcrumb è attivo
        let parentBreadcrumb2 = route.snapshot.data['breadcrumbParent'] ? this.translateService.instant(route.snapshot.data['breadcrumbParent']) : ''; // Ottiene il breadcrumb padre
        let urlId = this.router.routerState.snapshot.url;
        const match = urlId.match(/\/(\d+)\//);
        let parentBreadcrumbId;
        if (match) {
         parentBreadcrumbId = parseInt(match[1], 10);
        }
        let breadcrumbParentId2 = route.snapshot.data['breadcrumbParentId2']; // Ottiene il breadcrumb padre di II livello
        let child = route.snapshot.data['breadcrumb'] ? this.translateService.instant(route.snapshot.data['breadcrumb']) : ''; // Ottiene il breadcrumb figlio
        this.link = route.snapshot.data['linkBreadcrumbParent'];
        this.linkId = route.snapshot.data['linkBreadcrumbParentId'] + '/' + parentBreadcrumbId;
        this.linkParent2 = route.snapshot.data['linkBreadcrumbParentId2'] + '/' + parentBreadcrumbId + '/lista-obiettivi';
        this.breadcrumbs = {};
        this.title = title;
        this.breadcrumbs = {
          "parentBreadcrumb": parent,
          "parentBreadcrumb2": parentBreadcrumb2,
          "parentBreadcrumbId": parentBreadcrumbId,
          "breadcrumbParentId2": breadcrumbParentId2,
          "childBreadcrumb": child,
          "enable": isEnable
        }
      });
  }

}
